<div class="FormsPlacePicker">
    @if (isLoading) {
        <app-pg-loading [isOverlay]="true"></app-pg-loading>
    }
    <label class="visually-hidden" for="forms-place-picker-search">{{ 'forms-place-picker.a11y.search' | locTranslate }}</label>
    <input id="forms-place-picker-search" [hidden]="!mapReady" type="text" class="form-control form-control-sm FormsPlacePicker-Search" #searchbox
        [attr.aria-label]="'forms-place-picker.a11y.search' | locTranslate"
        [placeholder]="'forms-place-picker.a11y.search' | locTranslate"/>
    <div class="FormsPlacePicker-Map GoogleMaps" #gmaps role="region" [attr.aria-label]="'forms-place-picker.a11y.map' | locTranslate"></div>
</div>
